<template>
  <v-container fluid class="page-payManage">
    <!-- <div>555</div>
    <tree-menu :list="treedata" />
    <div>555</div> -->
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12">
        <v-toolbar color="white" flat>
          <v-toolbar-title class="text-h5">支付方式管理</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-actions class="pb-0 px-4">
            <v-subheader class="px-0">支付方式列表</v-subheader>
            <v-spacer></v-spacer>
            <v-btn outlined color="primary" @click.stop="clickAction(null, 'add')"> <v-icon left>mdi-plus</v-icon>新增 </v-btn>
          </v-card-actions>
          <v-card-text>
            <v-data-table :expanded.sync="expanded" @click:row="expandRow" :headers="headers" :items="list" item-key="id" :options.sync="pagination" :server-items-length="totalDesserts" :loading="loading" :item-class="itemClass" class="elevation-1 table-expanded-style">
              <template v-slot:[`item.id`]="{ item }">
                <div style="padding-left: 10px">
                  <i
                    :style="{
                      visibility: item.children && item.children.length > 0 ? 'visible' : 'hidden'
                    }"
                    :class="['mdi', 'mdi-24px', 'icon-arrow', item.expanded ? 'mdi-chevron-down' : 'mdi-chevron-right']"
                  ></i>
                  <span class="id">{{ item.id }}</span>
                </div>
              </template>
              <template v-slot:[`item.value`]="{ item }">
                <span class="id">{{ item.value ? item.value.split(":")[0] : "" }}</span>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="table-expanded-content">
                  <tree-menu v-if="item.children" :headers="headers" :list="item.children" @clickItem="clickAction" />
                </td>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn class="ma-2 white--text" small color="blue" @click.stop="clickAction(item, 'check')">查看</v-btn>
                <v-btn class="ma-2 white--text" small color="blue" @click.stop="clickAction(item, 'add')">添加子项</v-btn>
                <v-btn class="ma-2 white--text" small color="blue" @click.stop="clickAction(item, 'edit')">编辑</v-btn>
                <v-btn class="ma-2 white--text" small color="error" @click.stop="clickAction(item, 'delete')">删除</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="checkDialog" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">支付方式详情</span>
        </v-card-title>
        <v-card-text class="pay-modal-detail" v-if="currentItem">
          <div class="base-info">
            <p>名称：{{ currentItem.label }}</p>
            <p>id：{{ currentItem.id }}</p>
            <p>info：{{ currentItem.info }}</p>
            <p>value：{{ currentItem.value }}</p>
          </div>
          <div class="right" v-if="currentItem.childForm">
            <div class="item">
              <span class="label">表单配置项:</span>
              <div class="item-r">
                <ul class="form-ul">
                  <li v-for="(formItem, index) in currentItem.childForm" :key="index">
                    <span class="label">{{ formItem.title }}：</span>
                    <div class="v-input-box">
                      <v-text-field placeholder="请输入" v-model="formItem.value" solo required></v-text-field>
                      <p class="inputInfo">{{ formItem.info }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="normal" @click="checkDialog = false" text>取消</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDialog" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ edit ? "编辑" : "新增" }}支付方式</span>
        </v-card-title>
        <v-card-text class="pay-modal-detail">
          <div class="base-info">
            <v-form v-model="valid" ref="form">
              <ul class="form-ul">
                <li class="required">
                  <span class="label">名称：</span>
                  <div class="v-input-box">
                    <v-text-field ref="label" placeholder="请输入" v-model="form.label" solo required></v-text-field>
                  </div>
                </li>
                <li class="required">
                  <span class="label">value：</span>
                  <div class="v-input-box">
                    <v-text-field ref="value" placeholder="请输入" v-model="form.value" solo required></v-text-field>
                  </div>
                </li>
                <li class="">
                  <span class="label">info：</span>
                  <div class="v-input-box">
                    <v-text-field ref="info" placeholder="请输入" v-model="form.info" solo></v-text-field>
                  </div>
                </li>
              </ul>
            </v-form>
          </div>
          <div>
            <h2 class="">表单配置项:</h2>
            <div class="">
              <div class="text-right designer-top">
                <v-btn class="ma-2 white--text" small outlined color="blue" @click="importJsonDialog = true">导入Json</v-btn>
                <v-btn class="ma-2 white--text" small outlined color="blue" @click="getJson">查看Json</v-btn>
              </div>
              <fc-designer ref="designer">
                <template slot="handle"> </template>
              </fc-designer>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="addDialog = false" text>取消</v-btn>
          <v-btn color="primary" @click="addEditSubmit" text :disabled="!form.label || !form.value">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">提示</span>
        </v-card-title>
        <v-card-text class="pb-0" v-if="currentItem"> 确定要删除支付方式“{{ currentItem.label }}”（value：{{ currentItem.value }}）？<br /> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="deleteDialog = false" text>取消</v-btn>
          <v-btn color="error" @click="deleteItem" text>确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="jsonDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">查看Json</span>
        </v-card-title>
        <v-card-text class="pb-0 jsoneditor-vue-content">
          <vue-json-editor v-model="installConfig" :show-btns="false" :mode="'code'" lang="zh"></vue-json-editor>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="jsonDialog = false" text>取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="importJsonDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">导入Json</span>
        </v-card-title>
        <v-card-text class="pb-0 jsoneditor-vue-content">
          <vue-json-editor v-model="importInstallConfig" :show-btns="true" :mode="'code'" lang="zh" @json-save="onJsonSave"></vue-json-editor>
        </v-card-text>
        <v-card-actions class="footer-jsonedittor">
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="importJsonDialog = false" text>取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
import TreeMenu from './module/TreeMenu'
import vueJsonEditor from 'vue-json-editor'
export default {
  name: 'AppInfo',
  components: {
    TreeMenu,
    vueJsonEditor
  },
  data () {
    return {
      totalDesserts: 0,
      pagination: { page: 1, itemsPerPage: 10 },
      loading: true,
      expanded: [],
      list: [],
      headers: [
        // { text: '', value: 'data-table-expand', width: '30px' },
        { text: 'id', value: 'id', width: '100px' },
        { text: '名称', value: 'label', width: '100px' },
        { text: 'value', value: 'value', width: '100px' },
        { text: 'info', value: 'info', width: '200px' },
        { text: '操作', value: 'actions', width: '200px' }
      ],
      checkDialog: false,
      addDialog: false,
      deleteDialog: false,
      valid: true,
      form: {
        dataType: 0,
        info: '',
        label: '',
        value: ''
      },
      currentItem: null,
      edit: false,
      jsonDialog: false,
      installConfig: {},
      importJsonDialog: false,
      importInstallConfig: []
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getList()
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['platTypeList'])
  },
  created () {
    // this.getList()
  },
  methods: {
    getJson () {
      console.log(1111, this.$refs.designer)
      this.installConfig = this.$refs.designer.getRule()
      this.jsonDialog = true
    },
    onJsonSave (value) {
      this.$refs.designer.setRule(value)
      this.importJsonDialog = false
    },
    expandRow (item, event) {
      if (item.children && item.children.length > 0) {
        if (event.isExpanded) {
          var index = this.expanded.findIndex(i => i === item)
          this.expanded.splice(index, 1)
          item.expanded = false
        } else {
          this.expanded.push(item)
          item.expanded = true
        }
      }
    },
    addEditSubmit () {
      if (this.edit) {
        this.editSubmit()
      } else {
        this.addSubmit()
      }
    },
    // 添加
    addSubmit () {
      this.form.childForm = this.$refs.designer.getRule()
      if (this.currentItem) {
        this.form.parentId = this.currentItem.id
      }
      const request = buildAxios()
      request.post('configData/add', this.form).then(res => {
        this.addDialog = false
        this.$emit('alert', {
          msg: '添加成功',
          type: 'success'
        })
        this.pagination.page = 1
        this.getList()
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    // 编辑
    editSubmit () {
      this.form.childForm = this.$refs.designer.getRule()
      if (this.currentItem) {
        this.form.parentId = this.currentItem.parentId
        this.form.id = this.currentItem.id
      }
      const request = buildAxios()
      request.post('/configData/update', this.form).then(res => {
        this.addDialog = false
        this.$emit('alert', {
          msg: '编辑成功',
          type: 'success'
        })
        this.pagination.page = 1
        this.getList()
        console.log(res)
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    // 删除
    deleteItem () {
      const request = buildAxios()
      request.post('configData/delete', { id: this.currentItem.id }).then(res => {
        this.$emit('alert', {
          msg: '删除成功',
          type: 'success'
        })
        this.deleteDialog = false
        this.pagination.page = 1
        this.getList()
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    itemClass (item) {
      const l = item.leval > 5 ? 5 : item.leval
      return item.children ? 'hasChild padding-left-' + l : 'noChild padding-left-' + l
    },
    //  get list
    getList () {
      const request = buildAxios()
      //  dataType: 0 //数据类型 0：支付类型；1：厂商
      // request.get('configData/treePage')
      request.get('configData/treePage?page=' + (this.pagination.page - 1) + '&size=' + this.pagination.itemsPerPage + '&dataType=0')
        .then(res => {
          console.log(res.data.data)
          this.loading = false
          this.totalDesserts = res.data.data.totalSize
          const leval = 0
          this.initTree(res.data.data.data, leval)
          this.list = res.data.data.data
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    // action
    clickAction (item, type) {
      this.currentItem = item
      if (type === 'edit') {
        this.form = item
        // this.form = JSON.parse(JSON.stringify(item))
        this.form.value = this.form.value ? this.form.value.split(':')[0] : ''
        this.edit = true
        this.addDialog = true
        this.$nextTick(function () {
          this.$refs.designer.setRule(item.childForm || [])
        })
      } else if (type === 'delete') {
        this.deleteDialog = true
      } else if (type === 'add') {
        this.form = {
          childForm: {},
          info: '',
          label: '',
          value: '',
          dataType: 0
        }
        this.edit = false
        this.addDialog = true
      } else if (type === 'check') {
        this.checkDialog = true
      }
    },
    // 递归获取树层级
    initTree (list, leval) {
      console.log(list, leval)
      list.forEach(element => {
        this.$set(element, 'leval', leval)
        if (element.children && element.children.length > 0) {
          this.initTree(element.children, leval + 1)
        }
      })
    }
  },
  filters: {
  }
}
</script>
